module.exports = __webpack_public_path__ + "images/wheel-icon-halloween-cef8f4a50af052c935793a622623ca2d.png";